import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import API from 'api/API';
import { TurnaroundListFilters } from 'api/models/TurnaroundList';
import { QueryKeys } from 'api/models/QueryKeys';

export const useTurnaroundList = (params: TurnaroundListFilters) => {
  const { isAuthenticated } = useAuth0();

  return useQuery({
    queryKey: [QueryKeys.TurnaroundList, params],
    queryFn: async () => API.deliveries.getTurnaroundList(params),
    enabled: isAuthenticated,
  });
};
